module.exports = __webpack_public_path__ + "9882e68e56437367fc6a0737031f79e4.pdf";